export default {
  en: {
    closed: 'Voting is closed',
    total: {
      zero: 'Vote now!',
      one: '1 user voted',
      other: '%{count} users voted',
    },
  },
};
